import { Button } from 'antd/lib';
import Link from 'antd/lib/typography/Link';
import { usePairingContext } from 'hooks/usePairingContext';
import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';
import { IconType, NotificationModal } from './NotificationModal';

const PairingErrorModal = () => {
	const { t } = useTranslation('cameras');
	const {
		openPairingErrorModal,
		setOpenPairingErrorModal,
		pairingErrorRetryCallback,
	} = usePairingContext();

	const close = () => setOpenPairingErrorModal(false);

	return (
		<NotificationModal
			titleIconType={IconType.KO}
			title={t('installationModal.error.title')}
			body={
				<p>
					<Trans
						i18nKey="cameras:installationModal.error.explanation"
						components={[
							<Link key="mail-support" href="mailto:support@automatic.tv">
								{t('supportEmail')}
							</Link>,
						]}
					/>
				</p>
			}
			open={openPairingErrorModal}
			width={438}
			centered
			footer={null}
			closable={true}
			onCancel={close}
			onOk={close}
			footerBtns={[
				<Button
					key={0}
					type="ghost"
					aria-label="Try again"
					onClick={() => {
						close();
						pairingErrorRetryCallback.current?.();
					}}
				>
					{t('installationModal.error.confirm')}
				</Button>,
			]}
		/>
	);
};

export { PairingErrorModal };
